import OAuthUtil from './utils/OAuthUtil';
import jwtHelper from './utils/JwtHelper';
import q from 'q';

// EXPORT
var provider = {
    $get: ['oAuth', function (oAuth) {
        var oAuthUtil = OAuthUtil(oAuth);
        return {
            refreshAccessToken: function refreshAccessToken() {
                oAuthUtil.removeTokens();
                return oAuthUtil.requestAccessToken();
            },

            get accessToken() {
                return oAuthUtil.waitTokensSet().then(function (tokens) {
                    return tokens.accessToken;
                });
            },

            get accessTokenDecoded() {
                return oAuthUtil.waitTokensSet().then(function (tokens) {
                    return jwtHelper.decodeToken(tokens.accessToken);
                });
            },

            get grantedAuthorities() {
                var deferred = q.defer();

                oAuthUtil.waitTokensSet().then(function (tokens) {
                    var isAuthenticated = tokens.accessToken && !jwtHelper.isTokenExpired(tokens.accessToken);

                    if (!isAuthenticated) {
                        deferred.resolve([]);
                        return;
                    }

                    var scopes = jwtHelper.decodeToken(tokens.accessToken).scope;

                    var scopeAuthorities = oAuthUtil.filterScopeAuthorities(scopes);

                    deferred.resolve(scopeAuthorities.map(function (scope) {
                        var authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
                        var match = authorityRegex.exec(scope);
                        return {
                            authorityType: match[1].toUpperCase(),
                            value: match[2],
                            authorityLevel: match[3]
                        };
                    }));
                }).catch(function () {
                    deferred.resolve([]);
                });

                return deferred.promise;
            }
        };
    }]
};

export default provider;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/OAuthService.js
// module id = 1337
// module chunks = 0